/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import Proptypes from 'prop-types';
import {
  Box, Button, Dialog, DialogContent, DialogTitle, Divider, IconButton, Paper, Tooltip, Typography,
} from '@material-ui/core';
import {
  CloudDownload,
  CloudUpload,
  Delete,
  Send,
  Subtitles,
} from '@material-ui/icons';
import MaterialTable from 'material-table';
import logo from '../../../shared/img/empty2.png';
import generatePowerPoint from './generatePowerPoint';
import resourceServices from '../../../redux/services/resourceServices';
import { FileConvertSize, FormatDateWithTime } from '../../../helpers/utils';
import googleStorageServices from '../../../redux/services/googleStorageServices';
import { toastError, toastSuccess } from '../../../redux/actions/alertActions';

const DialogPPT = ({
  company,
  data,
  openPPT,
  setOpenPPT,
}) => {
  const [file, setFile] = useState({});
  const [filesList, setFilesList] = useState([]);

  const formatFilesArr = (arr, path) => {
    const finalArr = [];
    if (arr && arr.length > 0) {
      arr.forEach((pptFile) => {
        if (pptFile.name === `${path}Presentation_${company.name}.pptx`.replace(/\s/g, '_')) {
          // eslint-disable-next-line prefer-template
          const newName = pptFile?.name?.replace(path, '');
          pptFile.formatedName = newName;
          finalArr.push(pptFile);
        }
      });
    }
    return finalArr;
  };

  const getPresentationFilesData = async () => {
    const response = await resourceServices.getPresentationFiles();
    setFilesList(formatFilesArr(response[0], 'resources/ppt/'));
  };

  useEffect(() => {
    getPresentationFilesData();
  }, []);

  const handleDownload = async (filename, formatedName) => {
    const downloadedFile = await googleStorageServices.downloadFile(filename);
    const buffer = Buffer.from(downloadedFile.data[0]);
    const blob = new Blob([buffer]);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = url;
    a.download = formatedName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  };

  const handleDelete = async (filename) => {
    const deletedFile = await resourceServices.deletePresentationFile(filename, company._id);
    if (deletedFile.status === 200) {
      getPresentationFilesData();
      toastSuccess('File deleted successfully');
    } else {
      toastError('Deletion failed');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('uploadedFile', file);
    formData.append('company', company._id);

    const upload = await resourceServices.uploadPresentationFile(formData);
    if (upload.status === 200) {
      getPresentationFilesData();
      // setOpen(false);
      toastSuccess('File added successfully');
    } else {
      toastError('Failed to upload file');
    }
  };

  return (
    <Dialog
      open={openPPT}
      onClose={() => setOpenPPT(false)}
      aria-labelledby="power-point-download"
      aria-describedby="power-point-generation-and-upload"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Presentation power point</DialogTitle>
      <DialogContent>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Typography variant="body2">
            Download power point :
          </Typography>
          <IconButton
            onClick={() => generatePowerPoint(company, data, false)}
            variant="outlined"
            color="primary"
            style={{ marginRight: '17px', marginLeft: '15px' }}
          >
            <Subtitles />
          </IconButton>
        </Box>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
            gap: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={async () => {
                const blob = await generatePowerPoint(company, data, true);
                const formData = new FormData();
                formData.append('uploadedFile', blob, `Presentation_${company.name}.pptx`);
                formData.append('company', company._id);
                const upload = await resourceServices.uploadPresentationFile(formData);
                if (upload.status === 200) {
                  getPresentationFilesData();
                  // setOpen(false);
                  toastSuccess('File added successfully');
                } else {
                  toastError('Failed to upload file');
                }
              }}
            >
              Upload file as is
            </Button>
          </div>
          <Divider orientation="vertical" flexItem />
          <div style={{ width: '100%' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '15px',
              }}
            >
              <Send style={{ color: '#757575' }} />
              <Typography variant="subtitle2">
                Send a file
              </Typography>
            </div>
            <form
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                // border: '1.5px dashed #979797',
                padding: '20px',
                paddingBottom: '40px',
                marginBottom: '10px',
                backgroundColor: '#FFF',
                position: 'relative',
                height: '100%',
                width: '100%',
                maxWidth: '400px',
              }}
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <label htmlFor="file">
                  <input
                    style={{ display: 'none' }}
                    id="file"
                    name="file"
                    type="file"
                    onChange={(e) => { setFile(e.target.files[0]); }}
                  />
                  <IconButton
                    color="primary"
                    component="span"
                    aria-label="add"
                    variant="contained"
                  >
                    <CloudUpload style={{ fontSize: '40px' }} />
                  </IconButton>
                </label>
                {file.name
                  ? (
                    <span
                      style={{
                        color: '#979797',
                        position: 'absolute',
                        left: 0,
                        top: '85px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        textAlign: 'center',
                        width: '100%',
                      }}
                    >
                      {file.name}
                    </span>
                  )
                  : (
                    <span
                      style={{
                        color: '#979797',
                        position: 'absolute',
                        left: 0,
                        top: '85px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        textAlign: 'center',
                        width: '100%',
                      }}
                    >
                      Select a file
                    </span>
                  )}
              </div>
            </form>
            <Button
              type="submit"
              value="Envoyer"
              variant="contained"
              color="primary"
              fullwidth
              disableElevation
              onClick={handleSubmit}
              style={{
                width: '100%',
                maxWidth: '400px',
                marginBottom: '30px',
              }}
            >
              SEND
            </Button>
          </div>
        </Box>
        <MaterialTable
          title="Files list"
          data={filesList}
          columns={[
            {
              title: 'File',
              field: 'formatedName',
              render: ({ formatedName }) => {
                if (formatedName) {
                  return (
                    <Typography variant="body2">
                      {formatedName}
                    </Typography>
                  );
                }
                return (
                  <Typography variant="body2">
                    File without name
                  </Typography>
                );
              },
            },
            {
              title: 'Created at',
              field: 'metaData.timeCreated',
              render: (rowData) => {
                if (rowData.metadata?.timeCreated) {
                  return (
                    <Typography variant="body2">
                      {FormatDateWithTime(rowData.metadata.timeCreated)}
                    </Typography>
                  );
                }
                return (
                  <Typography variant="body2">
                    n/a
                  </Typography>
                );
              },
            },
            {
              title: 'Updated at',
              field: 'metaData.updated',
              render: (rowData) => {
                if (rowData.metadata?.updated) {
                  return (
                    <Typography variant="body2">
                      {FormatDateWithTime(rowData.metadata.updated)}
                    </Typography>
                  );
                }
                return (
                  <Typography variant="body2">
                    n/a
                  </Typography>
                );
              },
            },
            {
              title: 'File size',
              field: 'metaData.size',
              render: (rowData) => {
                if (rowData.metadata?.size) {
                  return (
                    <Typography variant="body2">
                      {FileConvertSize(rowData.metadata.size)}
                    </Typography>
                  );
                }
                return (
                  <Typography variant="body2">
                    n/a
                  </Typography>
                );
              },
            },
            {
              title: 'Download',
              field: 'name',
              render: (rowData) => {
                if (rowData.name) {
                  return (
                    <Tooltip title="Download file" placement="bottom">
                      <IconButton
                        onClick={() => handleDownload(rowData.name, rowData.formatedName)}
                      >
                        <CloudDownload style={{ fill: '#2687DC' }} />
                      </IconButton>
                    </Tooltip>
                  );
                }
                return (
                  <Typography variant="body2">
                    n/a
                  </Typography>
                );
              },
            },
          ]}
          options={{
            pageSize: 2,
            search: false,
          }}
          actions={[
            {
              icon: () => <Delete style={{ fill: '#CE2525' }} />,
              tooltip: 'Delete file',
              onClick: (event, rowData) => handleDelete(rowData.name),
            },
          ]}
          components={{
            // eslint-disable-next-line react/jsx-props-no-spreading
            Container: (containerProps) => (<Paper {...containerProps} elevation={0} />),
          }}
          style={{
            width: '100%',
            color: '#525252',
            boxShadow: 'none',
            marginTop: '30px',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

DialogPPT.propTypes = {
  company: Proptypes.object.isRequired,
  data: Proptypes.object.isRequired,
  openPPT: Proptypes.bool.isRequired,
  setOpenPPT: Proptypes.func.isRequired,
};

export default DialogPPT;
